import { Option } from '@blisspointmedia/bpm-types/dist/FilterBar';
import { FILTER_PARAM } from './batch-failures-constants';

// Reads the advanced filter bar's tokens from the page URL. Tokens are the same flat clause list
// BPMTable's defaultTokens.advanced accepts: field, operator, value, [and/or, field, operator,
// value, ...] -- e.g. `?filter=Investigator,is,jmanus`. Returns undefined when the param is
// absent or empty so the caller can fall back to the page's own default filter.
export const parseFilterTokens = (params: URLSearchParams): string[] | undefined => {
  const raw = params.get(FILTER_PARAM);
  if (!raw) return undefined;

  const tokens = raw
    .split(',')
    .map(token => token.trim())
    .filter(Boolean);

  return tokens.length > 0 ? tokens : undefined;
};

// Inverse of parseFilterTokens: flattens the filter bar's live Option chips back to the same
// raw clause list, for writing into the URL as the user edits the filter. Must serialize each
// token's `label` (the human-readable text, e.g. 'Job Name', 'is not like') rather than its
// `value` -- `value` is an internal `${name}~${index}` dedupe id (see makeNewOption in
// @blisspointmedia/bpm-types) that parseRawTokenArray's label-matching can never read back.
export const tokensToFilterParam = (tokens: Option[]): string =>
  tokens.map(token => token.label).join(',');

// Applies the advanced filter bar's current tokens to `current`'s ?filter param -- set when
// there's a filter, removed when the filter's been cleared -- without disturbing any other
// query params already on the URL.
export const withFilterParam = (current: URLSearchParams, tokens: Option[]): URLSearchParams => {
  const next = new URLSearchParams(current);
  if (tokens.length > 0) {
    next.set(FILTER_PARAM, tokensToFilterParam(tokens));
  } else {
    next.delete(FILTER_PARAM);
  }
  return next;
};
